__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "host";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("dayjs", "1.11.8", function() { return __webpack_require__.e(3464).then(function() { return function() { return __webpack_require__(23464); }; }); });
			register("next/dynamic", "12.3.7", function() { return __webpack_require__.e(3894).then(function() { return function() { return __webpack_require__(83894); }; }); });
			register("next/head", "12.3.7", function() { return __webpack_require__.e(5038).then(function() { return function() { return __webpack_require__(2657); }; }); });
			register("next/image", "12.3.7", function() { return __webpack_require__.e(7338).then(function() { return function() { return __webpack_require__(57338); }; }); });
			register("next/link", "12.3.7", function() { return __webpack_require__.e(4747).then(function() { return function() { return __webpack_require__(34747); }; }); });
			register("next/router", "12.3.7", function() { return __webpack_require__.e(5286).then(function() { return function() { return __webpack_require__(31242); }; }); });
			register("next/script", "12.3.7", function() { return __webpack_require__.e(6996).then(function() { return function() { return __webpack_require__(66996); }; }); });
			register("react-dom", "17.0.2", function() { return __webpack_require__.e(8884).then(function() { return function() { return __webpack_require__(43144); }; }); });
			register("react-redux", "7.2.6", function() { return __webpack_require__.e(2668).then(function() { return function() { return __webpack_require__(2668); }; }); });
			register("react/jsx-runtime", "17.0.2", function() { return __webpack_require__.e(3466).then(function() { return function() { return __webpack_require__(31085); }; }); });
			register("react", "17.0.2", function() { return __webpack_require__.e(1933).then(function() { return function() { return __webpack_require__(14041); }; }); });
			register("styled-components", "5.3.3", function() { return __webpack_require__.e(5387).then(function() { return function() { return __webpack_require__(85387); }; }); });
			register("styled-jsx/style", "5.0.7", function() { return __webpack_require__.e(6781).then(function() { return function() { return __webpack_require__(21543); }; }); });
			register("styled-jsx", "5.0.7", function() { return __webpack_require__.e(3633).then(function() { return function() { return __webpack_require__(6014); }; }); });
			initExternal(39965);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};